<script>
  export let label = "";
  export let required = false;
  export let value = "";
  export let fieldName = "";
  export let placeholder = "";
  export let rows = 5;
  let inputID = Math.random().toString(36).slice(2, 12);

</script>
{#if label}
  <label class="form-label" for={inputID}>
    {label}
    {#if required}
        <span class="text-red">*</span>
    {/if}
  </label>
{/if}
<style>
  textarea {
    height: unset;
  }
</style>
<textarea 
  class="form-control"
  {placeholder}
  name={fieldName}
  id={inputID}
  {required}
  rows={rows}
>{value}</textarea>
